module.exports = __webpack_public_path__ + "c8e31e77c68a48cfd582a5c0600c98db.png";